import React, { ComponentProps } from 'react';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { translatePartOfStringWithLink } from '../../lib/StringUtils/StringHTMLUtils';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Wysiwyg } from '../../_lib/components/Wysiwyg';

function PersonProfileEditHint({ supportEmailAddress, hint }: { supportEmailAddress: string; hint?: string }) {
  const { t } = useSonTranslation('PersonProfileEditHint');

  const text = translatePartOfStringWithLink(
    `PersonProfileEditHint:personprofileeditinfo`,
    supportEmailAddress ? `mailto:${supportEmailAddress}` : null,
  );

  const link = t('extraProfileEditInfo.link');

  return hint
    ? (
        <Wysiwyg content={hint} resourceReferencesToToUrls={{}} modifier="content-message" />
      )
    : (
        <>
          <ContentMessage text={text} />
          {/* SON-7671 - feature request 2 days before release */}
          {link !== '' && link !== 'null' && (
            <ContentMessage
              text={translatePartOfStringWithLink(`PersonProfileEditHint:extraProfileEditInfo.info`, link)}
            />
          )}
        </>
      );
}

export const PersonProfileEditHintBlock = asBlock(PersonProfileEditHint, BlockType.personprofileedithint);
export type PersonProfileEditHintBlock = ComponentProps<typeof PersonProfileEditHintBlock>;
